import { render, staticRenderFns } from "./EmergencyResponseTraining.vue?vue&type=template&id=23f1f99b&"
import script from "./EmergencyResponseTraining.vue?vue&type=script&lang=js&"
export * from "./EmergencyResponseTraining.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyResponseTraining.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports